import { type Vendor, Vendors } from '../vendor.enum';
import { BaseAsset } from './base-asset.interface';

// TODO: DirectoryUser and DirectoryUserListResponse are redundant intermediate types.
// They duplicate fields from UserAsset. The Google Directory API response (Schema$User)
// should be mapped directly to Partial<UserAsset> instead. Eliminating these requires
// refactoring DirectoryStrategy and DirectoryApiService to return UserAsset.
export interface DirectoryUser {
  userId?: string | null;
  customerId?: string | null;
  email?: string | null;
  name: {
    first?: string | null;
    last?: string | null;
    full?: string | null;
  };
  isAdmin?: boolean | null;
  isDeletedAdmin?: boolean | null;
  isSuspended?: boolean | null;
  /**
   * Google's `archived` flag. Distinct from `isSuspended`: an archived user
   * holds a licence but cannot sign in or be impersonated, so anything that
   * treats "suspended" as "unusable" must treat this the same way.
   */
  isArchived?: boolean | null;
  orgUnitPath?: string | null;
  userThumbnailPhotoUrl?: string;
  resource: unknown;
}

export interface DirectoryUserListResponse {
  users: DirectoryUser[];
  nextPageToken?: string;
}

export class GoogleUserData {
  userId?: string;
  customerId?: string;
  primaryEmail?: string;
  aliases?: string[];
  isAdmin?: boolean;
  isDelegatedAdmin?: boolean;
  suspended?: boolean;
  suspensionReason?: string;
  archived?: boolean;
  orgUnitPath?: string;
  recoveryEmail?: string;
  recoveryPhone?: string;
  creationTime?: Date | string;
  lastLoginTime?: Date | string;
  thumbnailPhotoUrl?: string;
  givenName?: string;
  familyName?: string;
  fullName?: string;
  isEnrolledIn2Sv?: boolean;
  isEnforcedIn2Sv?: boolean;
  includeInGlobalAddressList?: boolean;
  changePasswordAtNextLogin?: boolean;
  ipWhitelisted?: boolean;
  agreedToTerms?: boolean;
  isMailboxSetup?: boolean;
}

export class MicrosoftUserData {
  id?: string;
  userPrincipalName?: string;
  displayName?: string;
  givenName?: string;
  surname?: string;
  mail?: string;
  accountEnabled?: boolean;
  assignedLicenses?: Array<{ skuId?: string; disabledPlans?: string[] }>;
  createdDateTime?: Date | string;
  lastSignInDateTime?: Date | string;
  jobTitle?: string;
  department?: string;
  officeLocation?: string;
  mobilePhone?: string;
  businessPhones?: string[];
}

export class VendorUserData {
  [Vendors.GOOGLE]?: GoogleUserData;
  [Vendors.MICROSOFT]?: MicrosoftUserData;
}

export type RawVendorUserData = Partial<Record<Vendor, unknown | undefined>>;

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  ARCHIVED = 'ARCHIVED',
}

export class UserAsset extends BaseAsset {
  email!: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  orgUnitPath?: string;
  isAdmin!: boolean;
  isSuspended!: boolean;
  vendorProperties!: VendorUserData;
  rawVendorProperties!: RawVendorUserData;
}
